<template>
    <Diario class="pa-5" style="border-radius:0px;" />
</template>
<script>
import Diario from "@/components/ELECTRICALMARINE/Diario.vue";
export default {
  name: "EMDiario",
  components: {
      Diario,
  },
  props: {},
  data() {
    return {
        // Variabili d'appoggio
        // Modal
        // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {

  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>